import { createSlice } from '@reduxjs/toolkit';
import { getGiftsActiveByCampaign, giftsRedeemedByParticipant, redeemGift } from './GiftApi';

const initialState = {
  totalInventoryOfProducts: 0,
  participantHasAccessedGiftOrClosedInformativeModal: false,
  isLoadingProducts: false,
  isRedeemingGift: false,
  errorOnRedeemGift: null,
  showConclusionModal: false,
  giftInfo: {
    _id: '',
    name: '',
    description: '',
    status: '',
    createdAt: '',
    updatedAt: '',
    startDate: '',
    endDate: '',
    campaignId: null,
    catalogId: null,
    groups: [],
    type: null,
    products: [
      {
        name: '',
        description: '',
        inventory: 0,
        imageUrl: '',
        shippingDays: '',
        order: '',
        hasInventory: true,
        status: '',
        _id: '',
      },
    ],
    __v: 0,
  },
  redeemedGifts: [
    {
      _id: '',
      participantId: '',
      giftId: '',
      productId: '',
      status: '',
      createdAt: '',
      updatedAt: '',
      __v: 0,
      product: {
        _id: '',
        name: '',
        description: '',
        inventory: 0,
        imageUrl: '',
        shippingDays: '',
        order: '',
        hasInventory: true,
        status: '',
        createdAt: '',
        updatedAt: '',
        __v: 0,
      },
    },
  ],
  notAccessToGift: false,
};

const giftSlice = createSlice({
  name: 'giftSlice',
  initialState,
  reducers: {
    participantAlreadySawInformativeModal: (state) => {
      state.participantHasAccessedGiftOrClosedInformativeModal = true;
    },
    changeShowConclusionModal: (state, { payload }) => {
      state.showConclusionModal = payload;
    },
    setGiftAccess: (state, { payload }) => {
      state.notAccessToGift = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGiftsActiveByCampaign.pending, (state) => {
        state.isLoadingProducts = true;
      })
      .addCase(getGiftsActiveByCampaign.fulfilled, (state, { payload }) => {
        state.isLoadingProducts = false;
        state.giftInfo = payload;
        let totalInventory = 0;

        payload.products.forEach((product) => {
          totalInventory += product.inventory;
        });

        if (totalInventory === undefined) {
          totalInventory = 0;
        }

        state.totalInventoryOfProducts = totalInventory;
      })
      .addCase(getGiftsActiveByCampaign.rejected, (state, { payload }) => {
        state.isLoadingProducts = false;
      })
      .addCase(giftsRedeemedByParticipant.pending, (state) => {
        state.isLoadingProducts = true;
      })
      .addCase(giftsRedeemedByParticipant.fulfilled, (state, { payload }) => {
        state.isLoadingProducts = false;
        state.redeemedGifts = payload.map(
          (redeemedGift) => {

            return {
              ...redeemedGift.product,
              createdAt: redeemedGift.createdAt,
              shippingDate: redeemedGift.shippingDate,
            }
            
          }
        );
      })
      .addCase(giftsRedeemedByParticipant.rejected, (state) => {
        state.isLoadingProducts = false;
      })
      .addCase(redeemGift.pending, (state) => {
        state.isRedeemingGift = true;
      })
      .addCase(redeemGift.fulfilled, (state) => {
        state.isRedeemingGift = false;
        state.showConclusionModal = true;
      })
      .addCase(redeemGift.rejected, (state, { payload }) => {
        state.isRedeemingGift = false;
        state.errorOnRedeemGift = payload;
      });
  },
});

export const {
  participantAlreadySawInformativeModal,
  changeShowConclusionModal,
  setGiftAccess,
} = giftSlice.actions;

export default giftSlice.reducer;
